import { Component, inject, OnInit, EnvironmentInjector } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { RoutesHelper } from '@helpers/routes-helper';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthenticationService } from '@services/authentication';
import { filter } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly authenticationService = inject(AuthenticationService);
    private readonly injector = inject(EnvironmentInjector);

    public user$ = this.authenticationService.user$.pipe(untilDestroyed(this));
    public useLayout = true;

    private inactivityTimeout: ReturnType<typeof setTimeout>;
    private readonly inactivityLimit = 20 * 60 * 1000; // 20 minutes in ms

    public ngOnInit() {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            //const navEndEvent = event as NavigationEnd;
            // this.useLayout =
            //     !navEndEvent.urlAfterRedirects.includes(APP_ROUTES.LicenseUpdate) &&
            //     !navEndEvent.urlAfterRedirects.includes(APP_ROUTES.LicenseConfirmation);
        });
        this.resetInactivityTimer();
        this.addInactivityListeners();
    }

    private addInactivityListeners() {
        window.addEventListener('mousemove', this.resetInactivityTimer.bind(this));
        window.addEventListener('keydown', this.resetInactivityTimer.bind(this));
        window.addEventListener('mousedown', this.resetInactivityTimer.bind(this));
        window.addEventListener('touchstart', this.resetInactivityTimer.bind(this));
    }

    private resetInactivityTimer() {
        if (this.inactivityTimeout) {
            clearTimeout(this.inactivityTimeout);
        }
        this.inactivityTimeout = setTimeout(() => {
            this.handleAutoLogout();
        }, this.inactivityLimit);
    }

    private handleAutoLogout() {
        this.authenticationService.logout();
        this.injector.runInContext(() => {
            RoutesHelper.RunInContext.navigateToLoginAndTriggerLogout();
        });

        //await this.router.navigate(['/login']);
    }
}
